import { render, staticRenderFns } from "./TagEdit.vue?vue&type=template&id=9649cc64&scoped=true&"
import script from "./TagEdit.vue?vue&type=script&lang=ts&"
export * from "./TagEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TagEdit.vue?vue&type=style&index=0&id=9649cc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9649cc64",
  null
  
)

export default component.exports